import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import { getLogout, role } from "../Actions/AuthAction";

const LeftSidebar = (props) => {
  const logout = (e) => {
    //alert("fsdf");
    getLogout(props);
  };

  return (
    <>
      <div id="layoutSidenav_nav">
        <nav
          class="sb-sidenav accordion sb-sidenav-light"
          id="sidenavAccordion"
        >
          <div class="sb-sidenav-menu">
            <Link class="navbar-brand" to="/dashboard">
              <img
                src={`${config.DOMAIN_URL}/assets/img/logo.png`}
                class="logo"
              />
            </Link>
            <div class="nav mt-5">
              <Link class="nav-link active" to="/">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-tachometer-alt"></i>
                </div>
                Dashboard
              </Link>
              <a
                class="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseLayouts"
                aria-expanded="false"
                aria-controls="collapseLayouts"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa fa-handshake" aria-hidden="true"></i>
                </div>
                Jobs
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="collapseLayouts"
                aria-labelledby="headingOne"
                data-parent="#sidenavAccordion"
              >
                <nav class="sb-sidenav-menu-nested nav">
                  <Link to="/addjob" className="nav-link">
                    Add
                  </Link>
                  <Link to="/listjob" className="nav-link">
                    List
                  </Link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseLayoutsTwo"
                aria-expanded="false"
                aria-controls="collapseLayouts"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa fa-address-card"></i>
                </div>
                Drives
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="collapseLayoutsTwo"
                aria-labelledby="headingOne"
                data-parent="#sidenavAccordion"
              >
                <nav class="sb-sidenav-menu-nested nav">
                  <Link to="/addDrive" className="nav-link">
                    Add
                  </Link>
                  <Link to="/drivelist" className="nav-link">
                    List
                  </Link>
                </nav>
              </div>
              <a
                class="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseLayoutsThree"
                aria-expanded="false"
                aria-controls="collapseLayouts"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa fa-users"></i>
                </div>
                Candidates
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="collapseLayoutsThree"
                aria-labelledby="headingOne"
                data-parent="#sidenavAccordion"
              >
                <nav class="sb-sidenav-menu-nested nav">
                  <Link to="/allselectcandidatelist" className="nav-link">
                    Selected List
                  </Link>
                </nav>
              </div>

              <Link class="nav-link" to="/recruiterprofile">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-user"></i>
                </div>
                Profile
              </Link>

              <Link to="/support" class="nav-link">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-life-ring"></i>
                </div>
                Support
              </Link>
            </div>
          </div>
          <div class="sb-sidenav-footer">
            <div class="small">Logged in as:</div>
            <span class="text-danger font-weight-bold">{role()}</span>
          </div>
        </nav>
      </div>
    </>
  );
};
export default LeftSidebar;
